module.exports = __webpack_public_path__ + "img/verified.5c6a9983.png";